import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FAQ {
  question: string;
  answer: string;
}

const FAQSection = () => {
  const faqs: FAQ[] = [
    {
      question: 'How do I reserve a puppy?',
      answer: 'Just fill out our contact form or give us a call! We\'ll need a deposit to hold your puppy, and we\'ll walk you through everything including pickup and how to prepare.',
    },
    {
      question: 'What comes with each puppy?',
      answer: 'Your puppy comes with current vaccinations, deworming, a health certificate from our vet, microchip registration, starter food, health guarantee paperwork, and a care package with all the info you need.',
    },
    {
      question: 'Can I visit before I buy?',
      answer: 'Absolutely! We love when families visit. You can meet the puppies, see where they grow up, and ask us anything. Just call or email at least 48 hours ahead to schedule.',
    },
    {
      question: 'What payment methods do you take?',
      answer: 'We accept cash, certified checks, and bank transfers. Payment is handled directly (not through this website). You\'ll need a deposit to reserve your puppy, with the rest due at pickup. We\'ll give you all the payment details when you reserve.',
    },
    {
      question: 'Do you deliver puppies?',
      answer: 'We mainly do local pickup, but we can talk about delivery options if you\'re within our service area. There are extra fees for delivery. Just reach out and we\'ll figure out what works best.',
    },
    {
      question: 'What\'s your health guarantee?',
      answer: 'All our puppies come with a comprehensive health promise covering genetic health issues. Check out our Health Guarantee page for all the details on what\'s covered and our commitment to your puppy\'s health.',
    },
  ];

  return (
    <div className="rounded-xl bg-card p-8 shadow-warm">
      <div className="mb-6 flex items-center gap-3">
        <Icon name="QuestionMarkCircleIcon" size={28} className="text-primary" />
        <h2 className="font-heading text-2xl font-semibold text-foreground">
          Common Questions
        </h2>
      </div>

      <div className="space-y-5">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="border-b border-border pb-5 last:border-0 last:pb-0"
          >
            <h3 className="mb-3 flex items-start gap-2 font-heading text-lg font-semibold text-foreground">
              <Icon name="ChatBubbleLeftEllipsisIcon" size={20} className="mt-1 shrink-0 text-primary" />
              {faq.question}
            </h3>
            <p className="pl-7 text-muted-foreground">{faq.answer}</p>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-md bg-accent/10 p-5">
        <p className="flex items-start gap-3 text-sm text-foreground">
          <Icon name="LightBulbIcon" size={20} className="shrink-0 text-accent" />
          <span>
            <strong>Still have questions?</strong> We're here to help! Email: <a href="mailto:contact@luminexlabradors.com" className="font-medium text-primary hover:underline">contact@luminexlabradors.com</a> or fill out the contact form above. We'd love to help you find the perfect Lab for your family.
          </span>
        </p>
      </div>
    </div>
  );
};

export default FAQSection;